var _title;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLoginProdDefault = function SvgLoginProdDefault(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1068.03 630.16",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "New_Pattern_Swatch_13",
    "data-name": "New Pattern Swatch 13",
    width: 45.77,
    height: 45.77,
    patternTransform: "matrix(-0.44, 0, 0, 0.44, 1206.34, 1081.76)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 45.77 45.77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.77,
    height: 45.77,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.77,
    height: 45.77,
    style: {
      fill: "#d0d5da"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.87,
    cy: 18.06,
    rx: 1.34,
    ry: 1.1,
    transform: "translate(-8.81 20.05) rotate(-57.48)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.91,
    cy: 43.59,
    rx: 1.34,
    ry: 1.1,
    transform: "translate(-30.78 31.04) rotate(-57.48)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.86,
    cy: 29.57,
    rx: 1.05,
    ry: 0.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3,
    cy: 20.99,
    r: 1.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.27,
    cy: 41.09,
    r: 1.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.19,
    cy: 31.45,
    r: 1.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 5.01,
    r: 1.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.07,
    cy: 11.78,
    r: 1.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.87,
    cy: 16.52,
    rx: 1.1,
    ry: 1.34,
    transform: "translate(-1.62 29.34) rotate(-47.07)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.14,
    cy: 2.92,
    rx: 1.1,
    ry: 1.34,
    transform: "translate(5.88 19.34) rotate(-47.07)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.51,
    cy: 8.78,
    rx: 1.34,
    ry: 1.1,
    transform: "matrix(0.08, -1, 1, 0.08, 30.31, 50.44)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.78,
    cy: 1.8,
    rx: 1.34,
    ry: 1.1,
    transform: "matrix(0.08, -1, 1, 0.08, 34.75, 41.3)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.02,
    cy: 33.97,
    rx: 1.34,
    ry: 1.1,
    transform: "translate(-28.32 37.21) rotate(-85.34)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.8,
    cy: 42.16,
    rx: 1.34,
    ry: 1.1,
    transform: "translate(-39.45 41.53) rotate(-85.34)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.86,
    cy: 28.03,
    rx: 1.05,
    ry: 0.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.31,
    cy: 42.16,
    rx: 1.05,
    ry: 0.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.85,
    cy: 39.04,
    rx: 1.05,
    ry: 0.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.46,
    cy: 33.76,
    rx: 1.05,
    ry: 0.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.49,
    cy: 43.94,
    rx: 1.05,
    ry: 0.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.3,
    cy: 19.45,
    r: 1.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.65,
    cy: 29.43,
    r: 1.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.07,
    cy: 10.24,
    r: 1.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.65,
    cy: 2.71,
    r: 1.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.86,
    cy: 4.73,
    r: 1.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.16,
    cy: 24.89,
    r: 1.19,
    style: {
      fill: "#fff"
    }
  }))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Agillic_illu_Prod.login_done")), /*#__PURE__*/React.createElement("path", {
    d: "M906.73,375.56c66.69,39.46-100.85,22.52-87.33,36.85a3.51,3.51,0,0,0,1.48.91c70,22.79,50.24,62.18-5,70.1-23.34,3.35-119.63-3.5-65.4,8.44,61.66,13.58-8.85,40.36-8.85,40.36C686.56,559,550.4,516.73,564.39,551c7.7,16.62,13.13,24.59-3.62,36-32.69,22.29-113.22,15.92-193.24-.92s-120.11-49-89.57-71.75c11.86-8.85,109.85-6.12,35.32-27.28s-92-52.84-57.56-78.53c32-23.85,115-36.53,206.94-24.74,56.06,7.2,170.94,35.68,218.89,27a3.62,3.62,0,0,0,2.92-4.1c-1-7,11.54-26.25,33-34.19C776.87,350.43,867,352.07,906.73,375.56Z",
    style: {
      fill: "#f4d0c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520,508.22c44.36-1.35,74.88,1,104.09,1,48.26,0,77-6.58,77-19.75s-18.39-14.29-66.65-14.29c-26,0-61.31.32-88.41,2.68-11.92-4-29.55-6.49-49.24-6.49-35.9,0-65,8.36-65,18.68s29.11,18.68,65,18.68C499.83,508.78,520,508.22,520,508.22Z",
    style: {
      fill: "#dcb1a7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.94,
    cy: 534.85,
    rx: 73.84,
    ry: 29.57,
    style: {
      fill: "#dcb1a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.39,320.47c-77.57-2.88-245.45-4.39-210.84-43.19s77.3-45.86,7.89-69.25c-55.32-18.64-133-33.11-71.79-48.25C269.87,144.39,378,140,323.93,127.11S284.69,92.4,288.36,88.86c28-26.94,194.85-5,158.34-21.65-8.31-3.8-19.64-3.37-7.61-14.68,23.47-22.08,84.52-21.31,164-8.51,56.16,9,93.84,17.38,77.94,38.21-7.31,9.57-10.26,29.47,17.56,41.28,71.55,30.38,104.84,43.08,100.19,64.26-4.32,19.68-46.85,16.7-75.19,21.51-23.8,4-38.73,32.7-7,84.51C742.93,336.92,560,323.35,482.39,320.47Z",
    style: {
      fill: "#e3f2eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.74,152.81c-22.25,1.55-17.76,12.37-10.87,19.48,3,3.08-16.89,3.78-26.53,6.45s-6.32,7.63-5.34,8.17c15.65,8.67,59.06,5.35,73.64,5.62,15.38.28,71.73-1.78,68.37-7.7-5.77-10.15-56,1.77-14.81-19.71,15.68-8.19-20.35-11.81-35.15-12.39C423.5,152.09,400.91,151.22,390.74,152.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.94,66c-13.77,1-11,7.66-6.73,12.06,1.85,1.91-10.45,2.34-16.42,4s-3.91,4.72-3.31,5.06c9.7,5.37,36.56,3.31,45.59,3.48,9.52.17,44.4-1.1,42.31-4.77-3.57-6.28-34.63,1.1-9.16-12.2,9.71-5.06-12.6-7.31-21.75-7.66C594.22,65.57,580.24,65,573.94,66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6,351.94c-28.29,0-33.91-5.72-34.14-6a.34.34,0,0,1,0-.48.36.36,0,0,1,.49,0c0,.06,5.77,5.75,33.63,5.75,9.79,0,22.75-5.61,27-21.42,3.47-12.78-1.3-25.16-12.15-31.52a18.38,18.38,0,0,0-12.41-2.66c2.11,10.64,3.11,22.63-1.2,28.47a8.9,8.9,0,0,1-8,3.54c-6-.23-8.34-3.48-9.24-6.17-2.16-6.49,1.82-16.43,8.88-22.14a20.69,20.69,0,0,1,8.69-4.25,174,174,0,0,0-5.29-19.57.33.33,0,0,1,0-.29.37.37,0,0,1,.24-.17l29.91-5,7.49-38.28a.31.31,0,0,1,.15-.22.34.34,0,0,1,.26-.05l29.77,6.62,4.3-31.12a.36.36,0,0,1,.21-.27c10-4.18,23.37-.38,23.51-.34a.33.33,0,0,1,.24.31l4.78,64.43L139.26,190a.33.33,0,0,1,.18-.26c27.47-14.15,50.33-1.79,50.56-1.67a.35.35,0,0,1,.17.27l5.52,57.15c12.73-9.68,22.66-2.78,31.43,3.32,5.66,3.94,11,7.66,16.18,5.93,1.77-.58,2.77-1.34,3.08-2.3.53-1.67-1.12-3.94-2.73-6.14-1.87-2.56-3.81-5.22-2.78-7.45s5-3.64,12.56-4.22c21.66-1.66,33.15,9.45,36.88,16.65V212.36a.59.59,0,0,1,0-.13l13.93-35.72a.34.34,0,0,1,.32-.21h28.59a.35.35,0,0,1,.33.23l12.15,36.31,11.4-31a.32.32,0,0,1,.31-.22l26.39-.76a.31.31,0,0,1,.32.2l3.05,6.63a15.69,15.69,0,0,0,14,9.12l5.78-12.71a.33.33,0,0,1,.28-.2.3.3,0,0,1,.31.15L425,209.78l10.56,2.92,5.76-16.41a.34.34,0,0,1,.61-.08l20.15,30.58,7.83-22.15a.35.35,0,0,1,.29-.22.33.33,0,0,1,.33.15l5.6,8.71,22.43-30a.33.33,0,0,1,.29-.13l11,.76a.33.33,0,0,1,.24.12l17.17,20,2-7.73a.34.34,0,0,1,.36-.25l11,.76a.32.32,0,0,1,.27.16l15.4,25.84a.34.34,0,0,1,0,.17l.69,19.42,14.07-21.88a.35.35,0,0,1,.28-.15.37.37,0,0,1,.29.14l19.79,27.36a.31.31,0,0,1,.07.2v26l19.84-12.49V242a.34.34,0,0,1,.32-.34l10.72-.75c.55-3.24,6.65-33.45,42.09-33.45,35.26,0,38.87,29.23,39.17,32.68h14.34a.35.35,0,0,1,.35.34v27h8.1l-.72-50.58a.32.32,0,0,1,.06-.21l5.09-6.77,10.25-58.44a.34.34,0,0,1,.34-.28.33.33,0,0,1,.33.29l8,56.13,6.52,6.76a.31.31,0,0,1,.1.24v9.54h64.65l8.72-27.88a.35.35,0,0,1,.67,0l5.81,27.85h12.18a.34.34,0,0,1,.3.17l11,19.76a.32.32,0,0,1,0,.34.32.32,0,0,1-.29.17H853.3v20.94c-.12.67-2.66,15,9.73,18.15,4.91,1.24,9.22.65,12.15-1.66,3.09-2.45,4.62-6.65,4.54-12.49-.06-4.43-3.16-7.62-8.3-8.52a15.85,15.85,0,0,0-5.58,0,44.4,44.4,0,0,0,1.92,8.77c.84,2.81,1.45,4.84.64,6.15a3.3,3.3,0,0,1-2.42,1.34c-3.1.55-5.78-.22-7.35-2.11-1.8-2.19-2-5.57-.47-9.51,1-2.72,3.78-4.44,6.94-5.18a29.25,29.25,0,0,1,0-4.4V207.8a.34.34,0,0,1,.18-.3l53.52-28.88a.32.32,0,0,1,.41.07l15.4,16.72a.32.32,0,0,1,.09.23v19.47a13.25,13.25,0,0,0,18.58,12.13.34.34,0,0,1,.43.14l11.73,19.76a.41.41,0,0,1,.05.18v10.15l12-4.39a.37.37,0,0,1,.23,0l19.8,6.84a.36.36,0,0,1,.23.33v20.91l8.62-.69a21.06,21.06,0,0,0,19.28-20.88v-34.3a.34.34,0,0,1,.3-.34l10.17-1.51L1058,206.77a.33.33,0,0,1,.43,0l9.33,8.24a.35.35,0,1,1-.46.52l-9.11-8.06L1036.45,224a.33.33,0,0,1-.16.07l-10,1.48v34a21.76,21.76,0,0,1-19.92,21.57l-9,.71a.34.34,0,0,1-.37-.34v-21l-19.45-6.72-12.34,4.52a.33.33,0,0,1-.32,0,.35.35,0,0,1-.15-.28V247.41L953.25,228A13.94,13.94,0,0,1,934,215.11V195.77l-15.12-16.42L865.77,208v48.16a28.37,28.37,0,0,0,0,4.23,16.4,16.4,0,0,1,5.76,0c5.49,1,8.8,4.4,8.87,9.19.08,6.07-1.54,10.45-4.81,13-3.09,2.44-7.62,3.08-12.74,1.78-13-3.28-10.27-18.72-10.24-18.87V244.28a.34.34,0,0,1,.34-.34h6l-10.61-19.08H836.1a.34.34,0,0,1-.34-.27l-5.59-26.83-8.41,26.86a.33.33,0,0,1-.33.24H756.19a.35.35,0,0,1-.35-.34v-9.74l-6.5-6.74a.34.34,0,0,1-.09-.19l-7.76-54.11-9.89,56.4a.47.47,0,0,1-.06.15L726.47,217l.74,50.8a.37.37,0,0,1-.1.25.35.35,0,0,1-.25.1h-8.8a.34.34,0,0,1-.34-.34v-27H703.4a.34.34,0,0,1-.34-.33c0-.32-1.9-32.35-38.51-32.35S623.14,241,623.1,241.28a.33.33,0,0,1-.32.3l-10.67.74v19.44a.34.34,0,0,1-.17.29L591.42,275a.34.34,0,0,1-.35,0,.35.35,0,0,1-.18-.3V248.19l-19.43-26.86-14.39,22.38a.35.35,0,0,1-.64-.18l-.73-20.43-15.25-25.61-10.54-.73-2.12,8.09a.35.35,0,0,1-.26.24.34.34,0,0,1-.34-.11l-17.5-20.41L499,183.83l-22.61,30.26a.3.3,0,0,1-.29.13.36.36,0,0,1-.28-.15l-5.48-8.53-7.83,22.13a.32.32,0,0,1-.28.23.33.33,0,0,1-.33-.15l-20.15-30.58-5.63,16.06a.35.35,0,0,1-.42.22l-11-3a.33.33,0,0,1-.19-.14l-17.25-25.33-5.61,12.36a.35.35,0,0,1-.31.2A16.42,16.42,0,0,1,386.49,188l-2.95-6.43-25.93.75L346,214a.32.32,0,0,1-.33.22.34.34,0,0,1-.32-.23l-12.38-37H304.82L291,212.42v40.39a.36.36,0,0,1-.28.34.36.36,0,0,1-.38-.21c-2.81-6.87-14.11-19.4-36.86-17.65-7.13.55-11,1.8-12,3.82-.86,1.87.95,4.35,2.71,6.76s3.46,4.75,2.82,6.75c-.38,1.19-1.52,2.09-3.51,2.75-5.5,1.83-11-2-16.8-6-8.68-6-18.53-12.88-31.1-3a.32.32,0,0,1-.34.05.34.34,0,0,1-.21-.29l-5.56-57.58c-2.06-1.06-23.72-11.56-49.59,1.68l-10.86,84.38a.36.36,0,0,1-.35.3.35.35,0,0,1-.34-.32l-5-67.57c-1.79-.48-13.57-3.38-22.64.3L96.4,238.62a.33.33,0,0,1-.14.24.37.37,0,0,1-.27,0l-29.8-6.62-7.46,38.17a.35.35,0,0,1-.28.27l-29.74,5A168.53,168.53,0,0,1,33.94,295a19,19,0,0,1,12.9,2.75c11.13,6.52,16,19.2,12.47,32.29C55.69,343.33,44.81,351.94,31.6,351.94Zm1.75-56.15A19.75,19.75,0,0,0,25,299.88c-6.85,5.55-10.73,15.15-8.65,21.4,1.18,3.55,4.16,5.53,8.6,5.7a8.28,8.28,0,0,0,7.41-3.27C36.46,318.11,35.44,306.31,33.35,295.79Zm831.81-34.58c-2.91.7-5.42,2.27-6.36,4.74-1.41,3.71-1.28,6.84.36,8.83,1.41,1.7,3.85,2.38,6.7,1.88a2.74,2.74,0,0,0,2-1c.64-1.05.07-3-.72-5.59A45.7,45.7,0,0,1,865.16,261.21Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.75,402.27a11.55,11.55,0,0,1-4.59-.95c-11-4.66-30.9-1-31.1-.92a.35.35,0,1,1-.13-.69c.2,0,20.28-3.78,31.5,1,3.54,1.5,7.37,1.09,11.09-1.16a25.66,25.66,0,0,0,8.66-9.49c-8.31-.3-12.69-1.5-15.15-3.9-1.7-1.66-2.49-4-2.49-7.25,0-10.28,11.5-10.74,11.61-10.74a10.68,10.68,0,0,1,7.4,3.11c2,2.11,2.78,5.12,2.48,8.95a25.17,25.17,0,0,1-2.72,9.16c2.35.06,5,.06,8,0,18.36-.39,31.58-.43,33.87-.43V375.76H731.69a.35.35,0,0,1-.35-.35V350.3a.35.35,0,0,1,.35-.35h30.83V338.09H743a.35.35,0,0,1-.35-.35V315.23a.35.35,0,0,1,.35-.35h146.2a.35.35,0,0,1,.35.35v22.51a.35.35,0,0,1-.35.35H869.74V350h30a.35.35,0,0,1,.35.35v25.11a.35.35,0,0,1-.35.35H888.36v10.6a29,29,0,0,1,4,0c4.88.27,10.9,1.24,17.28,2.26,13.79,2.22,29.43,4.73,32.62-.78,4.66-8,2.58-37.61,2.55-37.91a.37.37,0,0,1,.17-.32.36.36,0,0,1,.36,0c4.6,2.67,17.7,6.18,34.35.41a.35.35,0,0,1,.3,0,.37.37,0,0,1,.16.26c.44,4.15,1.33,13.29,1.6,21a31.19,31.19,0,0,1,3.54-1.82c4.32-1.9,7.09-.86,8.64.34a9.79,9.79,0,0,1,3.29,6.22,65.45,65.45,0,0,1,12.19,4.71c35.4,17.7,36.56,17.68,50.71,17.38,2.07-.05,4.42-.1,7.21-.1a.35.35,0,0,1,.35.35.35.35,0,0,1-.35.35c-2.78,0-5.13.05-7.2.1-14,.29-15.48.33-51-17.45a65.57,65.57,0,0,0-11.76-4.6,17.52,17.52,0,0,1-.15,4.93c-.84,5.05-4.11,11.26-10.77,13.54a7.33,7.33,0,0,1-8.89-2.91,11.48,11.48,0,0,1-.89-10.51,5.23,5.23,0,0,1-.61-1.36c-.44-1.53-.62-5.06,5-8.73-.21-6-.77-13.61-1.54-21-18.48,6.27-31.18,1-33.94-.31.29,4.44,1.75,30-2.69,37.69-3.44,5.93-18.64,3.49-33.34,1.12-6.36-1-12.36-2-17.21-2.25a28.4,28.4,0,0,0-4,0v5.24c0,.13.21,3.78-1.73,5.4a3.74,3.74,0,0,1-3.47.57,5.44,5.44,0,0,1-3.87-6c.2-1.3,1.38-5,8.37-5.82v-11a.35.35,0,0,1,.35-.35h11.34V350.65h-30a.35.35,0,0,1-.35-.35V337.74a.35.35,0,0,1,.35-.35h19.44V315.58H743.33v21.81h19.54a.35.35,0,0,1,.35.35V350.3a.35.35,0,0,1-.35.35H732v24.41h10.48a.35.35,0,0,1,.35.35v13.86a.35.35,0,0,1-.35.35c-.14,0-14.09,0-34.21.43-3.14.07-5.91.07-8.36,0a26.37,26.37,0,0,1-9.07,10.06A13.66,13.66,0,0,1,683.75,402.27Zm203.91-15.14c-6.43.76-7.5,4.07-7.68,5.22a4.73,4.73,0,0,0,3.35,5.24,3.09,3.09,0,0,0,2.85-.43c1.67-1.39,1.48-4.8,1.48-4.84Zm89.46-4.66a10.75,10.75,0,0,0,1,9.46,6.58,6.58,0,0,0,8.09,2.64c6.36-2.18,9.49-8.14,10.3-13a17,17,0,0,0,.11-5c-5.18-1.31-10.68-1.69-14.78.55-.09,3.95-.52,6.72-1.53,6.87A3.92,3.92,0,0,1,977.12,382.47Zm-284-13.63c-.11,0-10.91.43-10.91,10,0,3.08.73,5.23,2.28,6.75,2.36,2.31,6.7,3.45,15,3.71a24.65,24.65,0,0,0,2.79-9.19c.29-3.63-.48-6.46-2.29-8.42A10,10,0,0,0,693.15,368.84Zm284.28,12.9a3.36,3.36,0,0,0,2.76,1.55c.59-.08.87-2.26.93-5.75A10.45,10.45,0,0,0,979,379.4,10.17,10.17,0,0,0,977.43,381.74Zm3.63-9.2c-4.88,3.32-4.75,6.37-4.37,7.71a5,5,0,0,0,.31.79,10.31,10.31,0,0,1,1.45-2.11,11.64,11.64,0,0,1,2.67-2.22C981.13,375.46,981.11,374.06,981.06,372.54Zm.72-.46c0,1.49.06,2.93.05,4.25,4.16-2.1,9.55-1.74,14.65-.5a8.89,8.89,0,0,0-3-5.47c-2-1.57-4.75-1.65-7.92-.26A29.33,29.33,0,0,0,981.78,372.08Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.83,351c-8.22,0-16.28-2.38-16.28-4.8,0-2.62,8-4,15.5-4s15.51,1.41,15.51,4S970.67,351,962.83,351Zm-.78-8.13c-8.72,0-14.8,1.75-14.8,3.33s7,4.1,15.58,4.1c8.43,0,14-2.47,14-4.1S970.78,342.86,962.05,342.86Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.72,348.46c-3.47,0-7-.8-7-2.33,0-3.06,14-3.06,14,0C969.71,347.66,966.19,348.46,962.72,348.46Zm0-4c-3.84,0-6.29,1-6.29,1.63s2.45,1.63,6.29,1.63,6.29-1,6.29-1.63S966.56,344.5,962.72,344.5Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.58,388.32H755.07a.35.35,0,0,1-.35-.35V375.41a.35.35,0,0,1,.35-.35H874.58a.35.35,0,0,1,.35.35V388A.35.35,0,0,1,874.58,388.32Zm-119.16-.7H874.23V375.76H755.42Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.86,350.65H772.39a.35.35,0,0,1-.35-.35V337.74a.35.35,0,0,1,.35-.35h87.47a.35.35,0,0,1,.35.35V350.3A.35.35,0,0,1,859.86,350.65Zm-87.12-.7h86.77V338.09H772.74Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.44,410.06a.4.4,0,0,1-.26-.12c-.63-.76-15.42-18.7-15.42-31.42a15.69,15.69,0,1,1,31.37,0c0,7.06-4.2,15.24-7.72,20.85a94.31,94.31,0,0,1-7.7,10.57A.34.34,0,0,1,692.44,410.06Zm0-46.53a15,15,0,0,0-15,15c0,11.55,13,28.12,15,30.64,2-2.44,15-18.4,15-30.64A15,15,0,0,0,692.44,363.53Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.6,418.12s-6.91,2.16-9.89.89l1.28,3.61,13,3.4c.85-2.12,0-4.89.35-6.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,426.23a.21.21,0,0,0,.19-.13,9.55,9.55,0,0,0,.34-4.18,8.81,8.81,0,0,1,0-2.26.21.21,0,0,0-.15-.26.23.23,0,0,0-.26.16,8.92,8.92,0,0,0,0,2.39,9.82,9.82,0,0,1-.25,3.82l-12.66-3.32-1.09-3.09c3.17.95,9.33-.95,9.6-1a.21.21,0,0,0,.14-.26.22.22,0,0,0-.27-.14c-.07,0-6.87,2.13-9.74.9a.19.19,0,0,0-.22,0,.2.2,0,0,0-.06.22l1.28,3.61a.17.17,0,0,0,.14.13l13,3.4Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.22,416.88l3,4.89a30.49,30.49,0,0,1-9.14,3.61l2.34,3.19,15.51-.43-6.8-15.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.4,428.78h0l15.51-.42a.23.23,0,0,0,.17-.1.2.2,0,0,0,0-.2L260.3,413a.21.21,0,0,0-.28-.1.21.21,0,0,0-.1.28l6.67,14.79-15.09.42-2.07-2.83a31.41,31.41,0,0,0,8.88-3.58.21.21,0,0,0,.07-.29l-3-4.88a.21.21,0,0,0-.29-.08.22.22,0,0,0-.07.29l2.87,4.71a30.29,30.29,0,0,1-8.89,3.47.22.22,0,0,0-.15.13.22.22,0,0,0,0,.21l2.34,3.18A.2.2,0,0,0,251.4,428.78Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.25,324.16s5.45,1.32,5.45,10.23S240.44,353.53,238,354s-11.71-.33-11.71-.33-5.44-9.73-4-17.16S233.84,322.18,242.25,324.16Z",
    style: {
      fill: "#d0e6dd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,302.05c-1.48-3,3.94-12.64,13-10.17s8.08,8.75,9.57,15.51,3.15,14.46,8.43,17.43,11.88.66,15.35,1.15,8.91,7.59,2,13.37-23.27,4.12-29.37-.5-6.77-12.7-6.77-12.7-12.83-2.25-14.06-9.61,6.93-4.08,1.85-14.48",
    style: {
      fill: "#2e4b6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.76,325.44s-11.63,6.8-12.75,6.31a29.83,29.83,0,0,0,4.71-10.39s1.85-6.19.74-7.8S230,311,230,309.23s1.91-2.23,1.42-3.71a11.38,11.38,0,0,1-1.29-2.42c-.13-.68,5.36-2.78,7.59-6.91,0,0,6.35,4.54,2.72,10.65l.82.1s1.92-4.15,3.72-2.23-.81,4.33-3.9,6.13S237.06,321.73,241.76,325.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.94,331.91l-.21-.09.14-.18a29.73,29.73,0,0,0,4.67-10.34c0-.06,1.82-6.12.77-7.64a7.87,7.87,0,0,0-2.09-1.73c-1.23-.82-2.4-1.59-2.4-2.7a3.14,3.14,0,0,1,.87-2c.43-.54.78-1,.56-1.64a11.24,11.24,0,0,1-1.3-2.46c-.06-.36.46-.7,1.61-1.44,1.71-1.1,4.57-2.94,6-5.59l.1-.18.16.12c.07,0,6.28,4.58,2.91,10.64l.43.05c.26-.51,1.32-2.49,2.59-2.7a1.49,1.49,0,0,1,1.36.55,2.11,2.11,0,0,1,.61,1.8c-.26,1.77-2.62,3.48-4.55,4.6-1.3.76-2.27,3-2.46,5.63-.2,2.83.52,6.59,3.16,8.68l.21.16-.23.13C240,326.69,230.9,332,229.13,332A.36.36,0,0,1,228.94,331.91Zm9.41-15.32c.2-2.77,1.23-5.09,2.64-5.91,2.63-1.53,4.19-3.07,4.38-4.34a1.74,1.74,0,0,0-.52-1.5,1.13,1.13,0,0,0-1-.44c-1.25.2-2.37,2.59-2.38,2.61l-.06.12-1.23-.15.14-.24a6.8,6.8,0,0,0,0-7.41,11.24,11.24,0,0,0-2.52-2.87c-1.5,2.64-4.32,4.45-6,5.55a6.33,6.33,0,0,0-1.44,1.06,10.51,10.51,0,0,0,1.26,2.35l0,0a2,2,0,0,1-.61,2,2.75,2.75,0,0,0-.8,1.76c0,.92,1.09,1.64,2.24,2.4a8.07,8.07,0,0,1,2.19,1.83c1.15,1.66-.64,7.69-.72,7.93a30,30,0,0,1-4.54,10.2c1.38-.23,7-3.2,12.09-6.18C238.86,323.21,238.15,319.44,238.35,316.59Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.85,306.09s-5.77-6-6.95-6.33l-.37.68.19.74s-1.86,2.42.18,3.72,3.4-1.18,3.4-1.18l2.85,3.22Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7,379.39a3.17,3.17,0,0,1-2.35-.62c-1.24-.86-1.73.62-1.73.62l3.34,2.48,4.08-1.49L261.31,374s-1.36-7.8-7.55-22.15-10-22.77-10-22.77-4.83-.37-6.06,6.93l11.38,19.55s-1.24,2.72,1.73,7.05,7.8,10.15,7.8,10.15l1.11,2.72a2,2,0,0,0-1.23,1.73A3.38,3.38,0,0,0,259.7,379.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.41,379.46l0-.13a1.62,1.62,0,0,1,.86-1,1.28,1.28,0,0,1,1.15.25,3.19,3.19,0,0,0,1.82.62,3.18,3.18,0,0,1-1-2.08,2.1,2.1,0,0,1,1.19-1.82l-1-2.54c-.32-.39-4.94-6-7.79-10.14-2.73-4-2-6.62-1.78-7.14l-11.34-19.47,0-.06v-.06c1.25-7.38,6.2-7.09,6.25-7.08h.11l0,.09c0,.09,3.91,8.58,10,22.77s7.55,22.12,7.56,22.18l1.77,6.59-4.33,1.58Zm5.72-5.48c0-.08-1.43-8-7.53-22.11-5.76-13.35-9.52-21.66-10-22.66-.69,0-4.64.31-5.75,6.71l11.35,19.5,0,.08,0,.08s-1.17,2.68,1.71,6.88,7.74,10.08,7.79,10.13l1.21,2.94-.17.07a1.8,1.8,0,0,0-1.12,1.56,3.17,3.17,0,0,0,1.17,2.09l.29.24-.37.08a3.37,3.37,0,0,1-2.49-.65,1,1,0,0,0-.82-.21,1.17,1.17,0,0,0-.59.62l3.15,2.33,3.84-1.39Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.54,387.4l.08,0a.21.21,0,0,0,.11-.28c-1.86-4.31-1.62-6.14-1.08-6.91a1.31,1.31,0,0,1,1-.59.21.21,0,0,0,.22-.2.21.21,0,0,0-.2-.22,1.72,1.72,0,0,0-1.41.77c-.86,1.25-.51,3.71,1,7.32A.23.23,0,0,0,259.54,387.4Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.97 380.09 254.46 391.15 264.53 413.26 273.27 417.55 293.4 401.21 276.38 381.19 269.97 380.09",
    style: {
      fill: "#f4d0c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.61,415.61l.1,0a.21.21,0,0,0,.09-.28L261,392l14-10a.21.21,0,1,0-.24-.34L260.46,391.9l.09.17,11.88,23.43A.2.2,0,0,0,272.61,415.61Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.73,392.18a.2.2,0,0,0,.21-.18.21.21,0,0,0-.18-.24L256,391.1a.22.22,0,0,0-.24.18.21.21,0,0,0,.18.24l4.79.66Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.79,385.75a.24.24,0,0,0,.13-.05.21.21,0,0,0,0-.29c-.23-.29-5.54-7.14-8.94-6.68a.22.22,0,0,0-.19.24.23.23,0,0,0,.24.18c3.19-.42,8.5,6.45,8.55,6.52A.23.23,0,0,0,271.79,385.75Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,390.7a.24.24,0,0,0,.14-.05.23.23,0,0,0,0-.3c-7-8.19-4.85-10.79-4.83-10.82a.21.21,0,0,0-.31-.28c-.11.11-2.48,2.83,4.82,11.37A.21.21,0,0,0,264.53,390.7Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.85,383h0a.21.21,0,0,0,.19-.23c-.18-1.82-2.73-3.08-2.84-3.14a.22.22,0,0,0-.28.1.21.21,0,0,0,.09.28s2.46,1.21,2.61,2.8A.22.22,0,0,0,265.85,383Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.25,353.69,208.6,418.12a8.53,8.53,0,0,0,4.7,1.49c2.72,0,30.44-36.14,30.93-52S238,354,238,354Z",
    style: {
      fill: "url(#New_Pattern_Swatch_13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,418.12l-16.58-25.74s6.44-10.64,7.18-19.3l19.06,43.81Z",
    style: {
      fill: "url(#New_Pattern_Swatch_13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.31,387.66l.74-31.43c12.37-2.47,40.58,2.23,40.58,2.23l-4.21,32.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630,388l.75-31.75V356l.27-.06c12.29-2.46,40.42,2.18,40.71,2.23l.33.05-4.29,33.33Zm1.44-31.46-.73,30.82,36.46,3.4,4.12-32C668.05,358.24,643,354.35,631.39,356.52Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.31,387.66l-.87-32.91c12.37-2.48,40.09,1.11,40.09,1.11l-3.82,31.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.08,354.46l.29,0c12.29-2.46,39.93,1.07,40.2,1.11l.35,0L666,388l-35.71,0H630Zm40.06,1.71c-3.2-.4-27.78-3.31-39.34-1.13l.85,32.27,34.75,0Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.89,367.55l-1.63-31.39c12.15-3.41,40.63-.85,40.63-.85l-1.73,32.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.56,367.89l-1.67-32,.27-.07c12.08-3.38,40.48-.88,40.76-.86l.34,0-1.77,33.57Zm-.94-31.47,1.6,30.78,36.61.64,1.69-32.21C660.31,335.36,635,333.38,623.62,336.42Zm1.26,31.13h0Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.46,333.08s-38.23-2.72-40.33.49l3.28,31.82,35.2-1.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.77,333.48l.07-.1c2.15-3.29,36.72-.93,40.65-.65l.34,0L660,363.66l0,.31-35.84,1.79Zm40.32-.08c-15.08-1.06-37.6-1.83-39.6.28L624.72,365l34.56-1.72Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.62,343.69l4.2-33.61c11.91,0,37.32,8.37,37.32,8.37l-6.31,30Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.23,344,634.47,310l0-.31h.37c11.86,0,37.12,8.3,37.37,8.39l.3.1-6.38,30.34-.06.32Zm4.9-33.56-4.12,33,34.55,4.7,6.17-29.41C668.88,317.76,646.27,310.54,635.13,310.43Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.08,342.56l1.58-33.84c11.87-1,37.86,5.45,37.86,5.45l-4,30.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.06,342.91l-.35,0,1.61-34.48.31,0c11.8-.95,37.71,5.38,38,5.45l.3.07-4,31.07ZM633,309.05l-1.55,33.18,34.81,2,3.88-29.81C667.21,313.73,644.1,308.29,633,309.05Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.95 475.81 462.22 233 650.94 235.53 647.21 475.81 465.95 475.81",
    style: {
      fill: "#e8eaed"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "659.85 230.81 453.19 227.69 451.81 218.31 663.67 221.96 659.85 230.81",
    style: {
      fill: "#606778"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "651.1 236.65 459.34 234.47 458.06 227.93 654.64 230.47 651.1 236.65",
    style: {
      fill: "#d0d5da"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "685.12 221.78 429.5 222.03 465.92 104.89 649.59 104.89 685.12 221.78",
    style: {
      fill: "#9ca4ba"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "589.78 71.3 587.44 114.55 533.43 114.83 531.09 70.45 589.78 71.3",
    style: {
      fill: "#e8eaed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.29,279.9s-27.3-12.08-45.75-31.11L664,276.69s9.92,20.88,42.78,30.17Z",
    style: {
      fill: "#ebedf1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.7,307.19c-32.64-9.22-42.9-30.14-43-30.35l-.08-.17,16.85-28.46.32.33c18.19,18.76,45.37,30.92,45.65,31l.39.17-19.76,27.31-.14.2Zm-26.09-57.83-16.2,27.34c1,2,11.64,21,42.24,29.75L725.76,280C722.36,278.47,697.68,266.8,680.61,249.36Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.56,298.64a.36.36,0,0,0,.31-.17l12.82-22a.35.35,0,1,0-.6-.36l-12.83,22a.36.36,0,0,0,.13.48A.33.33,0,0,0,651.56,298.64Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "656.12 294.7 648.82 308.27 649.51 288.02 656.12 294.7",
    style: {
      fill: "#e8eaed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,279.9s27.31-12.08,45.76-31.11l16.52,27.9s-9.92,20.88-42.78,30.17Z",
    style: {
      fill: "#ebedf1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.45,279.75l.41-.18c.27-.12,27.45-12.27,45.64-31l.32-.34,16.76,28.31.1.16-.08.17c0,.06-2.58,5.35-9.14,11.71-6,5.85-16.82,13.83-33.86,18.65l-.24.07Zm46.24-30.38C415.62,266.8,391,278.47,387.54,280l19.1,26.41c30.59-8.73,41.2-27.77,42.23-29.75Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.73,298.65a.41.41,0,0,0,.18,0,.36.36,0,0,0,.12-.49l-12.82-21.95a.36.36,0,0,0-.49-.13.37.37,0,0,0-.12.49l12.82,22A.36.36,0,0,0,461.73,298.65Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.17 294.7 464.48 308.27 463.78 288.02 457.17 294.7",
    style: {
      fill: "#e8eaed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.09,294.49a.35.35,0,0,1-.29-.15l-6.51-9.2a.35.35,0,0,1,0-.43.39.39,0,0,1,.43-.1l10.12,4.7-5.26-7a.35.35,0,0,1,.07-.5.37.37,0,0,1,.5.07l6.1,8.15a.36.36,0,0,1,0,.44.37.37,0,0,1-.43.09l-10.19-4.73,5.74,8.11a.36.36,0,0,1-.08.5A.37.37,0,0,1,410.09,294.49Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.51,288.52a.36.36,0,0,1-.29-.16l-5.72-8.21a.32.32,0,0,1-.06-.27.39.39,0,0,1,.15-.23l4.11-2.77a.36.36,0,1,1,.4.59L413.29,280l5.32,7.64,4-2.6a.35.35,0,0,1,.39.59l-4.29,2.79A.36.36,0,0,1,418.51,288.52Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.06,283.85a.36.36,0,0,1-.19-.66l3.15-2a.35.35,0,0,1,.49.11.35.35,0,0,1-.11.49l-3.15,2A.33.33,0,0,1,416.06,283.85Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,283.15a.36.36,0,0,1-.27-.12L420,275.15a.35.35,0,0,1,0-.5.36.36,0,0,1,.5.05l5.94,7-.32-4.2a.37.37,0,0,1,.17-.33.35.35,0,0,1,.38,0l3.25,2.13-4.58-9.28a.36.36,0,0,1,.16-.48.37.37,0,0,1,.48.16l5.16,10.46a.36.36,0,0,1-.09.42.35.35,0,0,1-.43,0L427,278.2l.36,4.57a.36.36,0,0,1-.22.36A.34.34,0,0,1,427,283.15Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.87,277.05a2.78,2.78,0,0,1-.58-.06,2.43,2.43,0,0,1-1.77-1.65.36.36,0,0,1,.21-.46.36.36,0,0,1,.46.21,1.7,1.7,0,0,0,1.25,1.2,2.94,2.94,0,0,0,2.48-.79,3.22,3.22,0,0,0-.42-4.15,3.64,3.64,0,0,0-3-.73,6.92,6.92,0,0,1-2-.11,2.78,2.78,0,0,1-2.05-1.88,2.39,2.39,0,0,1,.69-2.36,2.3,2.3,0,0,1,3.29,0,.35.35,0,0,1-.48.52,1.61,1.61,0,0,0-2.3,0,1.69,1.69,0,0,0-.52,1.67,2.09,2.09,0,0,0,1.54,1.38,6.5,6.5,0,0,0,1.84.09,4.23,4.23,0,0,1,3.49.93c1.57,1.58,1.52,4.07.42,5.17A3.86,3.86,0,0,1,434.87,277.05Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.69,52.31h0A.35.35,0,0,0,559,52l-.24-25.42a.35.35,0,0,0-.35-.35.34.34,0,0,0-.35.36L558.34,52A.35.35,0,0,0,558.69,52.31Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.1,237a.35.35,0,0,0,0-.7l-74.36-.92h0a.34.34,0,0,0-.34.34.34.34,0,0,0,.34.36l74.37.92Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548,239.05h36.62a.35.35,0,0,0,0-.7H548a.35.35,0,0,0,0,.7Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.62,307.77l6.94-13.14-5.34-5.21a.35.35,0,0,0-.49,0,.36.36,0,0,0,0,.5l5,4.85-5.35,10.13.49-64.56h-.35l-61.36-1.49a.35.35,0,0,0,0,.7l61,1.48Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.08,231.16,664,222.1a.36.36,0,0,0-.18-.46.34.34,0,0,0-.46.18l-3.73,8.64L628,230.1h0a.35.35,0,0,0,0,.7Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.54,222.55h0l73.52-.42a.33.33,0,0,0,.34-.35.35.35,0,0,0-.35-.35h0l-73.51.42a.35.35,0,0,0-.35.35A.35.35,0,0,0,611.54,222.55Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "600.24 75.02 522.37 75.1 535.27 48.91 582.45 48.91 600.24 75.02",
    style: {
      fill: "#9ca4ba"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.42,
    y1: 235.4,
    x2: 465.06,
    y2: 414.88,
    style: {
      fill: "none",
      stroke: "#152d46",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.710767474581917px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.08,306a.47.47,0,0,0,.16,0,.35.35,0,0,0,.15-.48l-5.78-10.73,5.71-5.18a.36.36,0,0,0,0-.5.35.35,0,0,0-.5,0l-6.11,5.55,6,11.21A.37.37,0,0,0,463.08,306Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.28,279.48h-.1a.35.35,0,0,1-.25-.36l.58-11.22-5.38,8.36a.35.35,0,1,1-.59-.39l6.09-9.48a.36.36,0,0,1,.41-.15.38.38,0,0,1,.25.36l-.58,11.14,4.54-7.5a.36.36,0,1,1,.61.37l-5.27,8.71A.36.36,0,0,1,681.28,279.48Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.71,284.92a.36.36,0,0,1-.2-.06l-4.19-2.94a.34.34,0,0,1-.09-.48l5.47-8.38a.41.41,0,0,1,.23-.16.32.32,0,0,1,.27.06l4.11,2.77a.37.37,0,0,1,.1.5.36.36,0,0,1-.5.09l-3.81-2.57L685,281.54l3.91,2.74a.34.34,0,0,1,.08.49A.35.35,0,0,1,688.71,284.92Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691,280.14a.31.31,0,0,1-.21-.07l-3-2.17a.36.36,0,1,1,.42-.58l3,2.18a.35.35,0,0,1,.09.49A.36.36,0,0,1,691,280.14Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.39,290.55a.4.4,0,0,1-.15,0,.34.34,0,0,1-.19-.39l.87-4.39-4.11,2a.35.35,0,0,1-.41-.07.36.36,0,0,1-.06-.42l4.82-9.11a.36.36,0,1,1,.63.33l-4.31,8.14,3.78-1.87a.38.38,0,0,1,.37,0,.34.34,0,0,1,.13.35L697,289l6.9-7.72a.35.35,0,0,1,.5,0,.36.36,0,0,1,0,.5l-7.77,8.69A.36.36,0,0,1,696.39,290.55Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.86,294.81a2.64,2.64,0,0,1-1-.18,3.71,3.71,0,0,1-2.08-2.54,2.42,2.42,0,0,1,.86-2.27.36.36,0,0,1,.51,0,.35.35,0,0,1,0,.5,1.73,1.73,0,0,0-.64,1.62,3,3,0,0,0,1.66,2,3.21,3.21,0,0,0,3.69-2c.45-1,0-2-.43-3a7.22,7.22,0,0,1-.66-1.93,2.77,2.77,0,0,1,1-2.6,2.4,2.4,0,0,1,2.45-.24,2.3,2.3,0,0,1,1.24,3,.36.36,0,0,1-.67-.26,1.6,1.6,0,0,0-.85-2.14,1.7,1.7,0,0,0-1.74.15,2.1,2.1,0,0,0-.71,1.94,7,7,0,0,0,.61,1.74c.49,1.11,1,2.26.44,3.59A4.13,4.13,0,0,1,703.86,294.81Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.86,15.52s-11.05,1.35-20.59-1.22l0,12.09s7.16,4.79,19.45,1.48l-9.33-5.58Z",
    style: {
      fill: "#d0e6dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.87 412.52 438.17 342.95 389.84 339.64 391.86 404.42 444.87 412.52",
    style: {
      fill: "#adb5be"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.17 342.95 427.12 420.8 368.56 414.15 383.72 338.5 438.17 342.95",
    style: {
      fill: "#e8eaed"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.25 351.05 423.89 415.47 376.03 408.11 387.07 344.38 431.25 351.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.72,361.15c5.46.51,28,2.11,28.2,2.12a.27.27,0,0,1,.24.28.25.25,0,0,1-.26.24h0c-.22,0-22.74-1.61-28.21-2.12a.26.26,0,0,1-.23-.29A.25.25,0,0,1,391.72,361.15Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.05,370.25c5.47.51,22.65,1.71,22.88,1.73a.26.26,0,0,1,.24.28.27.27,0,0,1-.26.24h0c-.23,0-17.42-1.22-22.89-1.73a.26.26,0,0,1-.23-.28A.26.26,0,0,1,390.05,370.25Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.93,365.53l16.14,1a.26.26,0,0,1,0,.52h0l-16.14-1a.26.26,0,0,1-.25-.27A.27.27,0,0,1,390.93,365.53Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.57 377.55 418.37 407.74 384.52 403.56 387.7 375.44 420.57 377.55",
    style: {
      fill: "#d0d5da"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "622.66 307.32 617.29 333.9 638.48 339.24 644.28 310.52 622.66 307.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "622.51 342.88 622.15 359.55 634.85 360.54 633.75 342.52 622.51 342.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "601.19 276.32 595.52 472.96 520.58 472.22 516.73 284.53 601.19 276.32",
    style: {
      fill: "#adb5be"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 586.47,
    cy: 370.73,
    rx: 4.78,
    ry: 5.14,
    style: {
      fill: "#9ca4ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.47,376.23a5.51,5.51,0,1,1,5.14-5.5A5.33,5.33,0,0,1,586.47,376.23Zm0-10.28a4.8,4.8,0,1,0,4.42,4.78A4.62,4.62,0,0,0,586.47,366Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "516.73 284.53 504.88 276.29 512.39 475.53 520.58 470.25 516.73 284.53",
    style: {
      fill: "#2e4b6b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "608 269.17 504.88 276.29 516.73 284.53 601.19 276.32 608 269.17",
    style: {
      fill: "#41607d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "601.19 276.32 608 269.17 604.5 417.29 597.26 412.61 601.19 276.32",
    style: {
      fill: "#d0d5da"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "597.43 406.39 604.89 401.13 603.03 478.83 595.41 472.29 597.43 406.39",
    style: {
      fill: "#f1f1f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606.47 489.87 507 487.66 506.15 481.02 608.82 483.61 606.47 489.87",
    style: {
      fill: "#d0d5da"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.73 498.65 499.88 496.97 498.81 492 612.74 493.68 611.73 498.65",
    style: {
      fill: "#adb5be"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "506.75 480.92 520.38 469.42 595.51 472.44 608.82 483.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "498.81 492 506.96 487.46 605.88 489.36 612.74 493.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.69,
    cy: 328.78,
    r: 28.06,
    style: {
      fill: "#f9e7e4",
      stroke: "#ec6567",
      strokeMiterlimit: 10,
      strokeWidth: "5.84848701953888px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.42,325.25a.64.64,0,0,1,.15-.4.43.43,0,0,1,.33-.2.52.52,0,0,1,.3.17l.37.36a1.69,1.69,0,0,0,.62.37,2.7,2.7,0,0,0,.93.16,2,2,0,0,0,1.33-.41,1.52,1.52,0,0,0,.48-1.21,1.61,1.61,0,0,0-.44-1.16,2.84,2.84,0,0,0-1.07-.68l-1.25-.5a2.78,2.78,0,0,1-1.08-.82,2.26,2.26,0,0,1-.44-1.43,2.64,2.64,0,0,1,.26-1.19,1.79,1.79,0,0,1,.7-.76,3.17,3.17,0,0,1,.9-.37,4,4,0,0,1,1-.12,4.91,4.91,0,0,1,1.54.23c.49.16.74.37.74.65a.72.72,0,0,1-.13.39.39.39,0,0,1-.34.21,4.36,4.36,0,0,1-.6-.25,3,3,0,0,0-1.21-.24,2.25,2.25,0,0,0-1.28.32,1.17,1.17,0,0,0-.49,1,1.2,1.2,0,0,0,.45,1,3.54,3.54,0,0,0,1.07.59c.42.15.84.32,1.25.51a2.58,2.58,0,0,1,1.07.91A2.73,2.73,0,0,1,548,324a2.54,2.54,0,0,1-.78,2,3,3,0,0,1-2.07.69,3.62,3.62,0,0,1-1.95-.49C542.68,325.89,542.42,325.57,542.42,325.25Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.69,317.56a.56.56,0,0,1,.1-.33.34.34,0,0,1,.29-.15h5.29a.34.34,0,0,1,.29.15.56.56,0,0,1,.1.33.61.61,0,0,1-.1.36.34.34,0,0,1-.29.15h-2.09v8.13a.34.34,0,0,1-.17.29.65.65,0,0,1-.38.1.67.67,0,0,1-.38-.1.34.34,0,0,1-.17-.29v-8.13h-2.1a.36.36,0,0,1-.29-.14A.62.62,0,0,1,548.69,317.56Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.42,326.14a.45.45,0,0,1,0-.11l2.66-8.65c.08-.25.3-.38.67-.38s.58.13.66.39l2.67,8.68a.11.11,0,0,0,0,.05v0a.37.37,0,0,1-.21.31.84.84,0,0,1-.46.13.36.36,0,0,1-.39-.24l-.58-1.93H556l-.57,1.92a.35.35,0,0,1-.39.25.84.84,0,0,1-.45-.13A.36.36,0,0,1,554.42,326.14Zm1.89-2.63h2.91l-1.45-4.9Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.28,326.22v-8.75a.32.32,0,0,1,.15-.28.61.61,0,0,1,.35-.11h4.58a.29.29,0,0,1,.27.15.52.52,0,0,1,.1.33.62.62,0,0,1-.1.37.31.31,0,0,1-.27.14h-4v3.31h2a.31.31,0,0,1,.28.13.52.52,0,0,1,.1.33.48.48,0,0,1-.1.31.31.31,0,0,1-.28.14h-2v3.93a.29.29,0,0,1-.16.27.67.67,0,0,1-.38.1.71.71,0,0,1-.39-.1A.3.3,0,0,1,562.28,326.22Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.75,326.22v-8.75a.32.32,0,0,1,.15-.28.58.58,0,0,1,.34-.11h4.58a.31.31,0,0,1,.28.15.52.52,0,0,1,.1.33.62.62,0,0,1-.1.37.32.32,0,0,1-.28.14h-4v3.31h2a.33.33,0,0,1,.28.13.59.59,0,0,1,.1.33.55.55,0,0,1-.1.31.34.34,0,0,1-.28.14h-2v3.93a.29.29,0,0,1-.16.27.71.71,0,0,1-.39.1.7.7,0,0,1-.38-.1A.29.29,0,0,1,568.75,326.22Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.57,337.83v-3.91a2.73,2.73,0,0,1,.76-2.15,3.36,3.36,0,0,1,4.08,0,2.73,2.73,0,0,1,.77,2.15v3.91a2.77,2.77,0,0,1-.77,2.16,3.4,3.4,0,0,1-4.08,0A2.77,2.77,0,0,1,545.57,337.83Zm1.09,0c0,1.24.57,1.85,1.71,1.85a1.69,1.69,0,0,0,1.27-.46,1.92,1.92,0,0,0,.45-1.39v-3.91a1.92,1.92,0,0,0-.45-1.39,1.73,1.73,0,0,0-1.27-.46c-1.14,0-1.71.62-1.71,1.85Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.93,340.2v-8.74c0-.25.19-.38.55-.38a.67.67,0,0,1,.46.17,1.51,1.51,0,0,1,.37.52l3.24,6.34v-6.65a.32.32,0,0,1,.17-.28.74.74,0,0,1,.38-.1.77.77,0,0,1,.38.1.32.32,0,0,1,.17.28v8.74a.34.34,0,0,1-.17.29.67.67,0,0,1-.38.1.79.79,0,0,1-.69-.49L554,333.55v6.65a.34.34,0,0,1-.17.29.65.65,0,0,1-.38.1.67.67,0,0,1-.38-.1A.34.34,0,0,1,552.93,340.2Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.49,340.2v-8.74a.32.32,0,0,1,.17-.28.74.74,0,0,1,.38-.1.77.77,0,0,1,.38.1.32.32,0,0,1,.17.28v8.14h3.55a.29.29,0,0,1,.26.15.68.68,0,0,1,.09.35.64.64,0,0,1-.09.34.29.29,0,0,1-.26.15H561a.6.6,0,0,1-.35-.1A.34.34,0,0,1,560.49,340.2Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.67,331.54a.39.39,0,0,1,.21-.33.93.93,0,0,1,.44-.13.45.45,0,0,1,.39.29l2.29,4.46,2.28-4.46a.45.45,0,0,1,.39-.29.9.9,0,0,1,.44.13.39.39,0,0,1,.21.33.49.49,0,0,1-.06.22l-2.69,5a.24.24,0,0,0,0,.13v3.29a.34.34,0,0,1-.17.29.67.67,0,0,1-.38.1.65.65,0,0,1-.38-.1.34.34,0,0,1-.17-.29v-3.29a.22.22,0,0,0,0-.13l-2.69-5A.63.63,0,0,1,564.67,331.54Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.82,382.72a2.4,2.4,0,1,0-4.78,0,2.6,2.6,0,0,0,1.15,2.19l-1,4.28h4.41l-.77-4.39A2.62,2.62,0,0,0,588.82,382.72Z",
    style: {
      fill: "#4a709a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589,389.54h-5.29l1.06-4.48a3,3,0,0,1-1.11-2.34,2.76,2.76,0,1,1,5.5,0,3,3,0,0,1-1,2.22Zm-4.38-.71h3.53l-.73-4.18.17-.13a2.28,2.28,0,0,0,.86-1.8,2,2,0,1,0-4.07,0,2.23,2.23,0,0,0,1,1.89l.21.14Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.61,488.41a.34.34,0,0,0,.33-.35.34.34,0,0,0-.32-.35l-21.7-.51c-.16,0-.33.15-.33.34a.34.34,0,0,0,.32.36l21.69.51Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.42,469.35l-13.25,11.49a.36.36,0,0,0,.21.62l14,.16h0a.33.33,0,0,0,.32-.33.33.33,0,0,0-.32-.34l-13.25-.15,13.19-11.38",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "640.82 475.66 603.03 478.83 603.88 444.68 640.82 475.66",
    style: {
      fill: "#e8eaed"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "607.86 298.6 608.32 268.79 504.88 276.29",
    style: {
      fill: "none",
      stroke: "#152d46",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.699999988079071px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "597.08 418.87 520.32 452.4 520.38 469.42 595.41 472.29 597.08 418.87",
    style: {
      fill: "#d0d5da"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "520.24 455.25 511.91 461.44 512.37 475.37 520.32 468.74 520.24 455.25",
    style: {
      fill: "#41607d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "636.54 373.57 622.11 366.04 631.07 350.78 644.28 358.33 636.54 373.57",
    style: {
      fill: "#d0d5da"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "678.81 459.78 678.92 498.1 627.23 498.33 630.06 458.29 678.81 459.78",
    style: {
      fill: "#f1f1f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "690.34 490.85 678.92 498.1 677.81 459.78 686.99 460.52 690.34 490.85",
    style: {
      fill: "#d0d5da"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.29 483.8 647.37 480.24 650.52 466.44 670.94 470.23 669.29 483.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "675.15 422.3 674.63 462.36 623.78 462.36 626.86 421.29 675.15 422.3",
    style: {
      fill: "#9ca4ba"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "686.73 428.38 675.15 422.3 674.63 462.36 684.81 460.44 686.73 428.38",
    style: {
      fill: "#2e4b6b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "658.24 443.62 637.19 450.74 633.52 437.06 653.35 430.85 658.24 443.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.67,512.26a.35.35,0,0,1-.35-.35l-1.67-108-7.86-2.71a.35.35,0,1,1,.23-.66l8.09,2.79a.35.35,0,0,1,.23.33L353,511.9a.35.35,0,0,1-.35.36Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.93,540.21h0l-75.35-.84a.34.34,0,0,1-.34-.35.35.35,0,0,1,.35-.35l75.1.84,1.25-3.6-52.74-2.58a.36.36,0,0,1-.34-.37.35.35,0,0,1,.37-.33l53.21,2.6a.37.37,0,0,1,.27.16.31.31,0,0,1,0,.31L439.26,540A.36.36,0,0,1,438.93,540.21Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 498.7 368.09 537.02 419.79 537.26 416.95 497.21 368.2 498.7",
    style: {
      fill: "#9ca4ba"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.67 529.77 368.09 537.02 369.2 498.7 360.02 499.44 356.67 529.77",
    style: {
      fill: "#2e4b6b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.67 525.1 397.04 529.92 401.53 513.93 387.92 509.95 382.67 525.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.5 450.13 364.44 450.65 364.44 501.5 405.5 498.42 404.5 450.13",
    style: {
      fill: "#f1f1f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.92 469.72 390.23 467.81 386.69 454.04 378.09 456.28 380.92 469.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.44 450.65 357.41 453.02 356.58 497.95 364.44 501.5 364.44 450.65",
    style: {
      fill: "#d0d5da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.92,540.44a.34.34,0,0,1-.34-.33l-6.69-136.23-31.6-11.64a.35.35,0,0,1-.2-.45.34.34,0,0,1,.44-.21l31.82,11.72a.36.36,0,0,1,.23.31l6.69,136.47a.34.34,0,0,1-.33.36Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.19 384.62 342.5 395.41 339.58 400.35 316.93 390.48 319.19 384.62",
    style: {
      fill: "#efb190"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.43,
    cy: 534.32,
    r: 18.42,
    style: {
      fill: "#9ca4ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.51,552.79A18.77,18.77,0,1,1,375.28,534,18.79,18.79,0,0,1,356.51,552.79Zm0-36.84A18.07,18.07,0,1,0,374.58,534,18.1,18.1,0,0,0,356.51,516Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.51,545.22a11.2,11.2,0,1,1,11.2-11.2A11.21,11.21,0,0,1,356.51,545.22Zm0-21.7A10.5,10.5,0,1,0,367,534,10.51,10.51,0,0,0,356.51,523.52Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.48,463.7a.35.35,0,0,1-.17,0l-8.37-4.75a.35.35,0,0,1-.13-.48.35.35,0,0,1,.47-.13l8.38,4.75a.35.35,0,0,1,.13.47A.36.36,0,0,1,360.48,463.7Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "589.41 76.63 531.49 78.53 531.27 75.13 589.67 75.03 589.41 76.63",
    style: {
      fill: "#d0d5da"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 561.09,
    cy: 95.02,
    rx: 12.41,
    ry: 11.96,
    style: {
      fill: "#2e4b6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560,108.49a13.34,13.34,0,1,1,13.83-13.34A13.6,13.6,0,0,1,560,108.49Zm0-26a12.64,12.64,0,1,0,13.13,12.63A12.9,12.9,0,0,0,560,82.52Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 589.98,
    cy: 129.95,
    rx: 0.69,
    ry: 0.7,
    transform: "translate(-13.48 101.69) rotate(-9.74)",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.7,155.83a.37.37,0,0,1-.33-.22.36.36,0,0,1,.2-.46l2.72-1.1-1-3.62a.35.35,0,0,1,.68-.19l1.17,4.22-3.3,1.34A.31.31,0,0,1,597.7,155.83Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.35,157h-.05a.35.35,0,0,1-.29-.4l.43-2.86,2.1,1a.35.35,0,0,1,.17.46.34.34,0,0,1-.47.17l-1.25-.58-.29,1.94A.35.35,0,0,1,600.35,157Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.77,154.17a.37.37,0,0,1-.33-.22.35.35,0,0,1,.19-.46l2.72-1.1-.83-2.63a.36.36,0,0,1,.23-.44.36.36,0,0,1,.44.23l1,3.24-3.31,1.35Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.42,155.34h0a.35.35,0,0,1-.3-.39l.43-2.86,2.1,1a.34.34,0,0,1,.17.46.34.34,0,0,1-.46.17l-1.25-.58-.29,1.94A.36.36,0,0,1,596.42,155.34Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.78,150.49l-1.18,0c-10.73-.49-11.61-14.61-11.67-16.21l-3.56-3.53,4.17-1c.24-.84,1.27-3.75,4.46-3.86,4.06-.17,5.35,6.51,5.56,7.83,10.7,3.84,15.89,3.24,18.36,2.07a3.82,3.82,0,0,0,2-1.86c1.43-2.62,3.22-4.18,5.35-4.7a8.19,8.19,0,0,1,6,1.11l.47.32L624.42,133a6.43,6.43,0,0,1,5.22,2.37l.53.75-.9-.21c-1.71-.39-3.92,1-4.93,1.77A3.43,3.43,0,0,1,626,139a5.91,5.91,0,0,1,.7,4l-.09.5-.44-.26a18.49,18.49,0,0,0-11.72-1.89c-.66.11-1.29,1-2.1,2.09C610.43,146.09,607.24,150.49,598.78,150.49Zm-15-19.39,2.87,2.85v.14c0,.16.35,15.18,11,15.67,9,.41,12.1-3.9,14.18-6.76.89-1.24,1.61-2.22,2.54-2.37a19.24,19.24,0,0,1,11.74,1.72,4.93,4.93,0,0,0-.64-3,2.91,2.91,0,0,0-1.94-1.18l-.73-.13.56-.48c.13-.1,2.73-2.31,5.15-2.42a5.77,5.77,0,0,0-6-1.07l-.29-.64,5.16-2.89a7.32,7.32,0,0,0-4.9-.71c-1.92.46-3.56,1.91-4.86,4.29h0a4.33,4.33,0,0,1-2.32,2.18c-2.6,1.27-8,1.94-19.16-2.09l-.2-.07,0-.21c0-.07-1-7.43-4.77-7.43H591c-3.14.11-3.82,3.37-3.84,3.51l0,.22Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.69,135.39q-.65,0-1.29-.06l-.24,0-.07-.23c-.05-.16-1.18-4,.25-6.15a3.06,3.06,0,0,1,2.35-1.34h0a1.87,1.87,0,0,1,1.58.31c1.29.87,2,3.1,2.16,6.64v.29l-.28.07A22.71,22.71,0,0,1,589.69,135.39Zm-1-.74a20.58,20.58,0,0,0,5-.38c-.2-3.86-1.1-5.27-1.82-5.78a1.25,1.25,0,0,0-1.06-.22,2.44,2.44,0,0,0-1.92,1C587.86,130.91,588.49,133.82,588.7,134.65Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.78,146.35a6.18,6.18,0,0,1-6.12-4.51.37.37,0,0,1,.25-.43.35.35,0,0,1,.43.25A5.88,5.88,0,0,0,596.1,145c1.7.88,3.9.81,6.53-.2a.35.35,0,0,1,.45.21.35.35,0,0,1-.2.45A11.57,11.57,0,0,1,598.78,146.35Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.42,143.73c-1,0-1.36-.26-1.46-.36a.36.36,0,0,1,0-.5.35.35,0,0,1,.47,0c.08.05,1.64.91,9.57-2.15a.35.35,0,1,1,.25.65C604.39,143.27,601.79,143.73,600.42,143.73Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.16,450.66c-.3,0-.51.39-.47.8s.33.72.63.68a.66.66,0,0,0,.47-.8C578.74,450.93,578.46,450.63,578.16,450.66Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.86,455.41a7.05,7.05,0,0,1-1.73.34l0-1.37a.76.76,0,0,0,.43-.58.64.64,0,1,0-1.23-.21.72.72,0,0,0,.4.81l0,1.35a2.22,2.22,0,0,1-1.83-.77.2.2,0,0,0-.28-.07.19.19,0,0,0-.07.27,2.59,2.59,0,0,0,2.33,1,6.74,6.74,0,0,0,2.11-.38.19.19,0,0,0,.12-.25A.19.19,0,0,0,577.86,455.41Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.82,452.38a10.7,10.7,0,0,0-5.69-.1c-.7-4.08-1.26-7.17-1.32-7.51a.33.33,0,0,0-.26-.28.33.33,0,0,0-.35.12l-2.1,2.6-6,0-1.75-3a.35.35,0,0,0-.29-.18.37.37,0,0,0-.3.16c-.74,1.18-1.45,4.13-2.09,7.76a9.08,9.08,0,0,0-4.28.6.2.2,0,0,0-.11.26.2.2,0,0,0,.26.12,8.65,8.65,0,0,1,4.06-.58c-.05.32-.11.65-.16,1a3.47,3.47,0,0,0-1.39.44.21.21,0,0,0-.08.28.21.21,0,0,0,.28.07,3.17,3.17,0,0,1,1.12-.38c-.68,4.24-1.26,9.08-1.68,13a11.94,11.94,0,0,1-6.85-2.79c-3.32-3-2.27-8.24.11-11.86,1.51-2.27,2.07-4,1.69-5.19a2,2,0,0,0-1.26-1.25,1.82,1.82,0,0,0-1.89.66,2.17,2.17,0,0,0-2.06-.53,2.23,2.23,0,0,0-1.5,2,4.14,4.14,0,0,0,2.6,3.72.35.35,0,0,0,.3-.63,3.44,3.44,0,0,1-2.21-3.05,1.54,1.54,0,0,1,1-1.42,1.56,1.56,0,0,1,1.4.43,1.66,1.66,0,0,0-.28,1.46.82.82,0,0,0,.84.45.81.81,0,0,0,.79-.49,1.61,1.61,0,0,0-.44-1.47c.32-.34.78-.64,1.16-.51a1.27,1.27,0,0,1,.83.81c.22.66.12,2-1.6,4.6-2.54,3.86-3.62,9.5,0,12.76a12.43,12.43,0,0,0,7.24,3c-.37,3.49-.61,6.18-.67,6.93L563.12,476a.34.34,0,0,0-.12.48.34.34,0,0,0,.3.17.26.26,0,0,0,.17-.05l2.82-1.67,1.6.67a9.69,9.69,0,0,0,1.31.4c-.18,2.08-.1,2.22-.05,2.28a.33.33,0,0,0,.29.15.33.33,0,0,0,.32-.46,14.55,14.55,0,0,1,.12-1.83,20.27,20.27,0,0,0,3.93.35,33.68,33.68,0,0,0,7.41-.9c.06.9.09,1.65.08,2.16a.35.35,0,0,0,.34.36h0a.34.34,0,0,0,.34-.34c0-.56,0-1.37-.08-2.34l1-.26h0l2.67-.9,2.4,1.62a.33.33,0,0,0,.19.06.35.35,0,0,0,.29-.15.34.34,0,0,0-.09-.48L586,473.74c.06-3.14-1.39-12.53-2.6-19.79a4.79,4.79,0,0,1,2.47.31.2.2,0,0,0,.17-.37,5.42,5.42,0,0,0-2.71-.35c-.05-.29-.1-.57-.14-.85a10.42,10.42,0,0,1,5.48.07.2.2,0,0,0,.26-.12A.21.21,0,0,0,588.82,452.38ZM558.76,448s-.07.05-.17.05-.16,0-.18,0a.89.89,0,0,1,.14-.62C558.75,447.72,558.8,448,558.76,448Zm23.88,5.6a14.45,14.45,0,0,0-2.66.7.2.2,0,0,0-.12.26.21.21,0,0,0,.19.13h.07a14.08,14.08,0,0,1,2.59-.68c1.2,7.2,2.65,16.53,2.61,19.64l-2.59.87-.88.22c-.4-4.93-1.48-12.87-1.53-13.29a.35.35,0,0,0-.4-.29.34.34,0,0,0-.29.39c0,.1,1.14,8.4,1.54,13.36a27.52,27.52,0,0,1-11.23.54c.35-3.42,1.12-9.54,1.7-14a.35.35,0,1,0-.69-.09c-1,7.49-1.46,11.63-1.68,13.95a9,9,0,0,1-1.1-.33l-1.53-.64c.15-1.78,1.12-12.49,2.43-20.68a6.38,6.38,0,0,1,2.71.86.23.23,0,0,0,.11,0,.2.2,0,0,0,.17-.09.21.21,0,0,0-.06-.28,6.74,6.74,0,0,0-2.86-.93c.05-.29.09-.58.14-.86a9.55,9.55,0,0,1,3,1,.23.23,0,0,0,.11,0,.2.2,0,0,0,.17-.09.21.21,0,0,0-.06-.28,10.16,10.16,0,0,0-3.16-1.08,34.73,34.73,0,0,1,1.71-6.94l1.53,2.62a.34.34,0,0,0,.3.17l6.37.05a.41.41,0,0,0,.27-.13l1.73-2.14c.21,1.2.66,3.72,1.18,6.8a16,16,0,0,0-2.45.84.2.2,0,0,0-.1.27.21.21,0,0,0,.18.12l.09,0a16.33,16.33,0,0,1,2.35-.8C582.56,453.11,582.6,453.37,582.64,453.63Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.16,452.14c.3,0,.58-.27.63-.68a.66.66,0,0,0-.47-.8c-.3,0-.58.27-.63.68S573.86,452.11,574.16,452.14Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.23 455.07 481.8 493.62 444.38 489.22 446.92 448.25 480.23 455.07",
    style: {
      fill: "#9ca4ba"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "499.3 437.31 480.23 454.07 481.8 493.62 502.27 484.36 499.3 437.31",
    style: {
      fill: "#2e4b6b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.82 486.99 465.75 487.3 466.04 471.74 475.47 471.97 475.82 486.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "495.33 470.46 487.64 473.08 485.96 467.04 493.21 464.78 495.33 470.46",
    style: {
      fill: "#4a709a"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.63,
    y1: 415.59,
    x2: 290.7,
    y2: 401.27,
    style: {
      fill: "none",
      stroke: "#152d46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.12,102.19a.35.35,0,0,0-.42.26l-.53,2.1h-6.54l.49-1.93a.36.36,0,0,0-.25-.43.36.36,0,0,0-.43.26L552,120.09a.36.36,0,0,0,.25.43h.09a.35.35,0,0,0,.34-.26l.6-2.39h6.54l-.56,2.21a.35.35,0,0,0,.25.43h.09a.36.36,0,0,0,.34-.26l4.45-17.65A.36.36,0,0,0,564.12,102.19ZM563,105.25l-1.41,5.62H555l1.42-5.62Zm-1.59,6.32-.62,2.45h-6.54l.62-2.45Zm-7.95,5.61.62-2.46h6.53l-.62,2.46Z",
    style: {
      fill: "#152d46"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.19 435.02 435.41 450.11 465.51 453.23 482.73 457.23 494.19 442.28 501.78 437.53 458.19 435.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.19 431.62 433.89 448.99 464.69 451.35 481.97 456.12 493.43 443.05 500.37 437.44 458.19 431.62",
    style: {
      fill: "#ebedf1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.41 431.04 433.87 444.61 465.27 449.34 481.19 454.01 494.17 441.5 501.11 436.09 457.41 431.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.46 429.5 433.64 443.83 465.43 447.51 481.72 451.72 494.25 440.27 499.36 436.84 459.46 429.5",
    style: {
      fill: "#ebedf1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.1 426.53 433.52 441.63 465.37 444.44 483.88 447.23 500 433.87 460.1 426.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.1 422.05 453.15 427.99 435.65 439.15 465.22 440.64 483.88 444.26 493.55 436.25 501.52 431.66 460.1 422.05",
    style: {
      fill: "#ebedf1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.65 423.64 451.95 427.26 438.71 435.69 465.17 438.36 483.81 442.67 494.31 433.5 501.39 429.45 454.65 423.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.43,432.74a.47.47,0,0,0-.25-.11c-3.28,0-6.63-.08-9.93-.31a.91.91,0,0,0,.07-.62c-.19-.63-1-1.19-5.83-.94a30.39,30.39,0,0,1-4.2-.06.56.56,0,0,0-.25-.31c3-1.2,8.68-3.71,8.42-5.25-.13-.77-1.32-.91-2.35-.95a6.88,6.88,0,0,0-5.41,1.75,6.43,6.43,0,0,0-1.7,4.23l-.24.22h-.06c-1.74-.28-1.65-1.43-1.34-3.45.22-1.43.46-3.06-.47-4.26a5.11,5.11,0,0,0-3.69-1.59c-2.05-.21-3.59.29-4.32,1.43a3.35,3.35,0,0,0,.19,3.56c1,1.81,3.56,3.74,7.64,4.74-10.94-1.62-19.19-3.73-19.33-3.77a.35.35,0,0,0-.17.68c.14,0,8.82,2.25,20.19,3.89l-7,6.31a.34.34,0,0,0-.12.27l.29,16.11a.35.35,0,0,0,.35.35h0a.36.36,0,0,0,.35-.36l-.28-16,7.3-6.59c3.33.46,6.87.87,10.48,1.16-.83.63-2.08,1.38-2.9,1.87-2.48,1.49-3.76,2.3-3.52,3.09.18.59,1.09.78,3.23.67a.35.35,0,1,0,0-.7l-1,0a3.53,3.53,0,0,1-1.56-.18c0-.42,1.95-1.55,3.21-2.31a21.28,21.28,0,0,0,3.51-2.39c3.34.24,6.74.38,10.07.36v9.4a.35.35,0,0,0,.35.35.35.35,0,0,0,.35-.35V433A.31.31,0,0,0,494.43,432.74Zm-19.22-6.31a6,6,0,0,1,4.43-1.55h.45c1.56.06,1.68.37,1.68.37.11.64-3.6,2.71-8,4.5A5.57,5.57,0,0,1,475.21,426.43Zm-11.54-.71a2.7,2.7,0,0,1-.2-2.83,3.26,3.26,0,0,1,2.87-1.16,7.45,7.45,0,0,1,.79,0,4.42,4.42,0,0,1,3.21,1.32c.75,1,.53,2.37.33,3.73-.19,1.18-.38,2.47.22,3.33C467,429.22,464.65,427.41,463.67,425.72Zm14.86,5.74c4.77-.25,5.1.37,5.12.44s0,.22-.15.36c-2.66-.2-5.29-.47-7.82-.78C476.58,431.52,477.53,431.51,478.53,431.46Z",
    style: {
      fill: "#152d46"
    }
  }));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoginProdDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/login_prod_default.a7f33bfe.svg";
export { ForwardRef as ReactComponent };